import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App/App';
import { svgAsPngUri } from 'save-svg-as-png';
import { select } from 'd3';


window.svgAsPngUri = svgAsPngUri;
window.select = select;

const rootEl = document.getElementById('root')

ReactDOM.render(
  <App />,
  rootEl
)

if (module.hot) {
  module.hot.accept('./components/App/App', () => {
    const NextApp = require('./components/App/App').default
    ReactDOM.render(
      <NextApp />,
      rootEl
    )
  })
}

let saveNode = select('body').append('div')
  .attr('id', 'save-node')
  .style('display', 'none')



// WEBPACK FOOTER //
// ./src/index.js